module.exports = __webpack_public_path__ + "img/banner.b958f760.png";